"use client"

import { Airplay } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `AirplayIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const AirplayIcon = component(Icon)({ as: Airplay })
